import React from 'react'
import { Box, Grid } from '@mui/material'
import { styled } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { Event } from '../../../swagger'
import LabelValue from '../Components/LabelValue'

const EventSection = styled('section')(({ theme }) => ({
  display: 'block',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
  marginTop: 0,
  paddingTop: 0,
}))

const FieldRow = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.customBackground?.divider}`,
  '&:last-of-type': {
    borderBottom: 'none',
    paddingBottom: 0,
  },
}))

const InternalEventInformationFields: React.FC<{ event: Event }> = ({
  event,
}) => {
  const { t } = useTranslation()
  const eventName = event?.name ?? ''
  const eventType = event?.eventType ?? ''
  const category = event?.category ?? ''
  const eventLocationType = event?.isOnline ? 'Global' : 'Local'
  const capacity = event?.capacity ?? ''
  const owner = event?.owner ?? ''

  return (
    <EventSection aria-labelledby="eventDetailsHeader">
      <Box sx={{ pt: 1, pb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FieldRow>
              <LabelValue
                label={t('Events.EventInformation.Name', 'Name')}
                value={eventName}
                variant="body1"
              />
            </FieldRow>

            <FieldRow>
              <LabelValue
                label={t('Events.EventInformation.EventType', 'Event Type')}
                value={eventType}
              />
            </FieldRow>

            <FieldRow>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <LabelValue
                    label={t('Events.EventInformation.Capacity', 'Capacity')}
                    value={capacity}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelValue
                    label={t(
                      'Events.EventInformation.LocationType',
                      'Location Type'
                    )}
                    value={eventLocationType}
                  />
                </Grid>
              </Grid>
            </FieldRow>
          </Grid>

          <Grid item xs={12} md={6}>
            <FieldRow>
              <LabelValue
                label={t('Events.EventInformation.Category', 'Category')}
                value={category}
              />
            </FieldRow>

            <FieldRow>
              <LabelValue
                label={t('Events.EventInformation.EventOwner', 'Event Owner')}
                value={owner}
              />
            </FieldRow>
          </Grid>
        </Grid>
      </Box>
    </EventSection>
  )
}

export default InternalEventInformationFields
